import styled from "@emotion/styled";

export const SideBarWrapper = styled.div`
  width: 18%;
  display: flex;
  flex-direction: column;
  row-gap: 15px;
`;

export const MyPageFont = styled.p`
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  color: black;
`;

export const InfoFont = styled.p`
  font-size: 18px;
  font-weight: bold;
  margin: 25px 0 0 0;
`;

export const InfoListFont = styled.p`
  font-size: 15px;
  color: rgb(144 144 144);
  margin: 0;
  cursor: pointer;
`;
